var map = {
	"./blog.yml": 184,
	"./cloud.yml": 185,
	"./color.yml": 186,
	"./country.yml": 187,
	"./dio.yml": 188,
	"./doc.yml": 189,
	"./emoji.yml": 190,
	"./git.yml": 191,
	"./icon.yml": 192,
	"./license.yml": 193,
	"./link.yml": 194,
	"./metrics.yml": 195,
	"./people.yml": 196,
	"./soft.yml": 197,
	"./src.yml": 198,
	"./status.yml": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 183;